import type { AboutCopy } from '../types/about';

export const aboutFr: AboutCopy = {
  seo: {
    title: 'À propos',
    description:
      'SafestMenu est conçu et exploité par transfactor.dev, une équipe de développement senior basée à Bucarest, en Roumanie - certifiée ISO 9001 et ISO/IEC 27001.',
  },
  hero: {
    eyebrow: 'À propos',
    heading:
      'Conçu par des personnes qui développent des logiciels pour gagner leur vie - et qui sortent beaucoup au restaurant.',
  },
  story: {
    intro:
      'SafestMenu est né d’une observation toute simple\u00A0: les menus papier coûtent cher à réimprimer, sont impossibles à tenir à jour, passent entre les mains de centaines de clients, et finissent à la poubelle par piles entières. Chaque restaurateur à qui nous avons parlé avait le même problème - et aucun temps à consacrer à une solution compliquée.',
    easyIntro:
      'Nous avons donc conçu le menu que nous voudrions dans notre propre restaurant\u00A0: un menu que l’on met en place en quelques minutes, que l’on met à jour depuis son téléphone, et que l’on n’imprime plus jamais. ',
    easyHighlight: 'Facile à utiliser',
    easyOutro: ' n’était pas une fonctionnalité sur une liste - c’était tout l’enjeu.',
    imageAlt: 'Une carte de table SafestMenu avec QR code sur une table de café, à côté d’un espresso',
  },
  team: {
    heading: 'L’équipe derrière SafestMenu',
    linkIntro: 'SafestMenu est conçu et exploité par ',
    linkText: 'transfactor.dev',
    linkOutro:
      ', une équipe de développement senior basée à Bucarest, en Roumanie. transfactor.dev conçoit, développe et livre des produits web, des systèmes d’IA et des outils internes - plus de vingt produits livrés et dix-huit années d’expérience cumulée, en travaillant certifié ISO 9001 et ISO/IEC 27001.',
    reliability:
      'Cela compte pour vous d’une manière bien concrète\u00A0: SafestMenu n’est pas un projet secondaire qui disparaîtra l’année prochaine. Il est maintenu, sécurisé et amélioré par la même équipe, chaque semaine.',
  },
  beliefs: {
    heading: 'Ce en quoi nous croyons',
    items: [
      'Un logiciel pour restaurants devrait être plus simple que la gestion d’un restaurant.',
      'Les clients méritent des menus honnêtes\u00A0: prix clairs, vraies photos, allergènes indiqués.',
      'Moins de papier à la poubelle, c’est bon pour tout le monde - votre budget y compris.',
    ],
  },
  cta: {
    label: 'Essayez SafestMenu gratuitement',
  },
};
